import { SudoButton } from "src/sudokit/components/SudoButton";
import { Text } from "src/sudokit/components/Text";

type Props = {
  onRetry: () => void;
};

export function TiptapErrorFallback({ onRetry }: Props) {
  return (
    <div className="flex flex-col items-center justify-center p-6 rounded-lg border border-[var(--grey-2,#e0e0e0)] min-h-[120px]">
      <div className="text-[var(--grey-1,#666)] mb-3">
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
          />
          <line
            x1="12"
            y1="8"
            x2="12"
            y2="12"
          />
          <line
            x1="12"
            y1="16"
            x2="12.01"
            y2="16"
          />
        </svg>
      </div>
      <div className="flex flex-col items-center justify-center">
        <Text className="text-lg font-medium">Oh no... Something went wrong</Text>
        <p className="text-sm text-[var(--grey-1,#666)] m-0 mb-4 text-center">
          We couldn't load your content, please refresh the page and try again.
          <br />
          If nothing works,{" "}
          <a
            className="underline"
            href="mailto:hi@sudowrite.com"
          >
            contact support.
          </a>
        </p>
      </div>
      <SudoButton
        variant="secondary"
        onClick={onRetry}
      >
        Retry
      </SudoButton>
    </div>
  );
}
